import PrizeDropCreate from './prize-drop.create';

export default {
  create: PrizeDropCreate,
};
